//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { differenceInCalendarDays as diffInDays } from "date-fns";
import {
  BOOKED_LESSONS_STATUS,
  CANCELED_REQUEST_STATUS,
  CANT_AFFORD_PRICE_STATUS,
  CLIENT_UNDECIDED_STATUS,
  CLIENT_UNREACHABLE_STATUS,
  DECLINED_RESPONSE,
  NO_AVAILABLE_TUTOR_STATUS,
  NO_RESPONSE,
  PAID_LESSON_FEE_STATUS,
  PAID_SPEAKING_FEE_STATUS,
  PENDING_REQUEST_STATUS,
  PROSPECTIVE_REQUEST_STATUS,
} from "./request";

const filterStatus = {
  ACTIVE: {
    name: "active",
    status: [
      PENDING_REQUEST_STATUS,
      PAID_SPEAKING_FEE_STATUS,
      PAID_LESSON_FEE_STATUS,
    ],
  },
  BOOKED: {
    name: "booked",
    status: [BOOKED_LESSONS_STATUS],
  },
  CANCELED: {
    name: "canceled",
    status: [
      CLIENT_UNREACHABLE_STATUS,
      CANCELED_REQUEST_STATUS,
      CANT_AFFORD_PRICE_STATUS,
      CLIENT_UNDECIDED_STATUS,
      NO_AVAILABLE_TUTOR_STATUS,
    ],
  },
  DECLINED: {
    name: "declined",
    status: [DECLINED_RESPONSE, NO_RESPONSE],
  },
  PROSPECTIVE: {
    name: "prospective",
    status: [PROSPECTIVE_REQUEST_STATUS, PAID_SPEAKING_FEE_STATUS],
  },
};

export const filterOptions = [
  { label: "Active", value: filterStatus.ACTIVE.name },
  { label: "Booked", value: filterStatus.BOOKED.name },
  { label: "In-progress", value: filterStatus.PROSPECTIVE.name },
  { label: "Canceled", value: filterStatus.CANCELED.name },
  { label: "Declined", value: filterStatus.DECLINED.name },
];

export const getActiveBookings = (bookings = []) => {
  const withLastBooked = bookings.filter((o) => o.bookedDate);

  const activeStatus = filterStatus.ACTIVE.status;

  const activeBookings = bookings.filter((booking) => {
    let declinedStatus = filterStatus.DECLINED.status;
    let isActive =
      activeStatus.includes(booking.jobInfo.requestStatus) &&
      !declinedStatus.includes(booking.jobInfo.tutorResponse.status);
    return isActive;
  });
  const bookedLessons = withLastBooked.filter((booking) => {
    console.log(diffInDays(new Date(), new Date(booking.bookedDate)));
    return (
      booking.jobInfo.requestStatus === BOOKED_LESSONS_STATUS &&
      diffInDays(new Date(), new Date(booking.bookedDate)) < 2
    );
  });

  return [...activeBookings, ...bookedLessons];
};

export const getBookedRequests = (bookings = []) => {
  const bookedRequests = bookings.filter(
    (booking) => booking.jobInfo.requestStatus === BOOKED_LESSONS_STATUS,
  );

  return bookedRequests;
};

export const getProspectiveRequests = (bookings = []) => {
  const prospectRequests = bookings.filter((booking) =>
    filterStatus.PROSPECTIVE.status.includes(booking.jobInfo.requestStatus),
  );

  return prospectRequests;
};

export const getCanceledRequests = (bookings = []) => {
  const cancalStatus = filterStatus.CANCELED.status;
  const cancelRequests = bookings.filter((booking) =>
    cancalStatus.includes(booking.jobInfo.requestStatus),
  );

  return cancelRequests;
};

export const getDeclinedRequests = (bookings = []) => {
  const declinedStatus = filterStatus.DECLINED.status;
  const declinedRequests = bookings.filter((booking) => {
    return declinedStatus.includes(booking.jobInfo.tutorResponse.status);
  });
  return declinedRequests;
};

export const filterBookings = (filter, bookings) => {
  if (filter === filterStatus.BOOKED.name) {
    return getBookedRequests(bookings);
  }
  if (filter === filterStatus.CANCELED.name) {
    return getCanceledRequests(bookings);
  }
  if (filter === filterStatus.DECLINED.name) {
    return getDeclinedRequests(bookings);
  }
  if (filter === filterStatus.PROSPECTIVE.name) {
    return getProspectiveRequests(bookings);
  }

  return getActiveBookings(bookings);
};
